import apiClient from '../index';

export const getDepartments = async () => {
  try {
    const response = await apiClient.get('/api/department/');
    const data = response.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (data?.data && Array.isArray(data.data)) {
      return data.data;
    }
    if (data?.departments && Array.isArray(data.departments)) {
      return data.departments;
    }
    return [];
  } catch (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }
};

export const getDepartmentById = async (deptId) => {
  if (!deptId) {
    throw new Error('Department ID is required');
  }
  
  try {
    const response = await apiClient.get(`/api/department/${deptId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching department:', error);
    if (error.response?.status === 404) {
      throw new Error('Department not found');
    }
    throw error;
  }
};

export const createDepartment = async (departmentData) => {
  if (!departmentData?.name) {
    throw new Error('Department name is required');
  }

  try {
    const response = await apiClient.post('/api/department/', departmentData);
    return response.data;
  } catch (error) {
    console.error('Error creating department:', error);
    throw error;
  }
};

export const updateDepartment = async (departmentId, departmentData) => {
  if (!departmentId) {
    throw new Error('Department ID is required');
  }
  
  if (!departmentData?.name) {
    throw new Error('Department name is required');
  }

  try {
    const response = await apiClient.put(`/api/department/${departmentId}`, departmentData);
    return response.data;
  } catch (error) {
    console.error('Error updating department:', error);
    if (error.response?.status === 404) {
      throw new Error('Department not found');
    }
    throw error;
  }
};

export const deleteDepartment = async (deptId) => {
  if (!deptId) {
    throw new Error('Department ID is required');
  }
  
  try {
    const response = await apiClient.delete(`/api/department/${deptId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting department:', error);
    if (error.response?.status === 404) {
      throw new Error('Department not found');
    }
    throw error;
  }
};